<template>
  <div class="media-div">
    <img
      v-if="renderAs === 'img'"
      :src="link"
      :alt="alt"
      :title="title"
      :class="{ 'fill-width': fillWidth }"
    />

    <div
      v-if="renderAs === 'div'"
      class="media-div__inner"
      :title="title"
      :style="{ backgroundImage: `url(${link})` }"
    ></div>
  </div>
</template>

<script>
// import config from "@/config";

export default {
  name: "Media",
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: "Image"
    },
    title: {
      type: String,
      default: ""
    },
    fillWidth: {
      type: Boolean,
      default: false
    },
    renderAs: {
      type: String,
      default: "img"
    }
  },
  computed: {
    link: function() {
      return `${this.src}`;
    }
  }
};
</script>

<style scoped>
.fill-width {
  width: 100%;
  height: auto;
}
.media-div__inner {
  display: block;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding-top: 100%;
}

img {
  height: 100%;
  width: 100%;
}
</style>